/* eslint-disable no-unused-vars */
import { Close, Search } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";

const MuiSearch = ({ callback, initialValue = "" }) => {
  const [innervalue, setinnervalue] = useState(initialValue);
  const [isHovering, setIsHovering] = useState(false);
  
  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  useEffect(() => {
    callback(innervalue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innervalue]);

  const handleReset = () => {
    setinnervalue("");
  };
  return (
    <Box component="form" sx={{ display: "flex", alignItems: "flex-end" }}>
      <TextField
        id="search"
        label="Search"
        variant="outlined"
        size="small"
        sx={{ width: "400px", pb: "20px" }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {innervalue !== "" ? (
                <IconButton onClick={handleReset} edge="end">
                  <Close sx={{ color: "red", width: "1ch", height: "1em" }} />
                </IconButton>
              ) : null}
            </InputAdornment>
          ),
        }}
        type="text"
        autoComplete="off"
        className="searchBarInput"
        value={innervalue}
        onChange={(e) => setinnervalue(e.target.value)}
      />
    </Box>
  );
};

export default MuiSearch;
